var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('v-col',[_c('h2',[_vm._v("Delete Profile Fields")]),_c('p',[_vm._v("Deleting "+_vm._s(_vm.profileFieldValues.length)+" records")]),_c('p',[_c('v-btn',{on:{"click":_vm.del}},[_vm._v("Delete")])],1)]),_c('v-col')],1)}
var staticRenderFns = []

export { render, staticRenderFns }